import PropTypes from "prop-types";
import SuperRecordListStore from "./SuperRecordListStore";
import { clientFilteredList } from "./SuperRecordActions";
import TableStore from "data/TableStore";
import typedAction from "data/util/typedAction";
import { superRecordPacketType } from "data/selectors/superRecords";

const SuperRecordListActions = {
    START_LOAD: "super-record-list/start-load",
    LOADED: typedAction("super-record-list/loaded", {
        key: PropTypes.string.isRequired,
        data: PropTypes.arrayOf(superRecordPacketType).isRequired
    }),
    LOAD_ERROR: "super-record-list/load-error",
};

export default SuperRecordListActions;

// Deprecated-ish :)
export const getSuperRecordListRecords = entityKey =>
    clientFilteredList(
        SuperRecordListStore,
        TableStore,
        entityKey,
    );



// WEBPACK FOOTER //
// ./app/data/SuperRecordListActions.js